import React from "react";
import { AppleFilled, AndroidFilled, LaptopOutlined } from "@ant-design/icons";
import { getStaffAuditDevice } from "../helpers/staff-audit-log-presentation-helper";


const platforms = {
    ios: { label: "iOS", Icon: AppleFilled },
    android: { label: "Android", Icon: AndroidFilled },
    web: { label: "Web", Icon: LaptopOutlined },
};

const StaffAuditDeviceField = ({ auditLog }) => {
    const device = getStaffAuditDevice(auditLog);
    const platform = typeof device.platform === "string" && device.platform.trim() ? device.platform : "—";
    const platformKey = platform.trim().toLowerCase();
    const presentation = Object.prototype.hasOwnProperty.call(platforms, platformKey) ? platforms[ platformKey ] : null;
    const PlatformIcon = presentation?.Icon;

    if (platform === "—" && device.deviceUUID === "—")
    {
        return <span>—</span>;
    }

    return (
        <span className="staff-audit-device">
            <span className="staff-audit-device__platform">
                { PlatformIcon &&
                    <PlatformIcon className="staff-audit-device__icon" aria-hidden="true" />
                }
                <span>{ presentation?.label || platform }</span>
            </span>
            <span className="staff-audit-device__id">{ device.deviceUUID }</span>
        </span>
    );
};

export default StaffAuditDeviceField;
